import { useState, useEffect } from "react";
import "./LivrosFavoritos.css";
import ReadingBookConcept from "../imagem/ReadingBookConcept.png";
import iconOlhoAberto from "../imagem/iconOlhoAberto.svg";
import Checkbox from "@mui/material/Checkbox";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import Favorite from "@mui/icons-material/Favorite";
import ModalInfoLivro from "../modais/ModalInfoLivro.js";

export default function LivrosFavoritos({
  livros = [],
  favoritar,
  desfavoritar,
  carregarDados,
}) {

  const livrosExibidos = livros;
  const [indice, setIndice] = useState(0);
  const [abrirModal, setAbrirModal] = useState(false);
  const [livroSelecionado, setLivroSelecionado] = useState(null);

  useEffect(() => {
    carregarDados();
  }, []);

  const handleVisualizar = (livro) => {
    const livroFormatado = {
      id: livro.idLivro,
      nome: livro.titulo,
      sinopse: livro.sinopse,
      avaliacao: livro.avaliacao ?? "Sem avaliação",
      genero: livro.genero,
      livrosDisponiveis: livro.livrosDisponiveis ?? 1,
      data: livro.anoPublicacao ?? "Ano desconhecido",
      favorito: livro.favorito ?? "favorito",
      quantidadeEstrelas: livro.estrelas,
      quantidadeAvaliacoes: livro.avaliacoes,
      autor: livro.autor,
      favoritado: livro.favoritado,
    };

    setLivroSelecionado(livroFormatado);
    setAbrirModal(true);
  };

  const proximo = () => {
    if (indice < livrosExibidos.length - 3) {
      setIndice(indice + 1);
    }
  };

  const anterior = () => {
    if (indice > 0) {
      setIndice(indice - 1);
    }
  };

  function formatarGeneros(prop) {
    const nomesGeneros = prop?.map((g) => g.nome);
    return nomesGeneros.join(", ");
  }

  return (
    <>
      <div className="carrossel-wrapper">
        <button
          className="seta seta-esquerda"
          onClick={anterior}
          disabled={indice === 0 || livrosExibidos.length === 0}
        >
          &lt;
        </button>

        <div className="carrossel-container">
          <div
            className="carrossel"
            style={{
              transform: `translateX(-${indice * (190 + 45)}px)`,
              transition: "transform 0.5s ease-in-out",
            }}
          >
            {livrosExibidos.length > 0 ? (
              livrosExibidos.map((livros) => (
                <div key={livros.idLivro} className="card-livro">
                  <div className="favorito">
                    <Checkbox
                      checked={true}
                      onChange={() =>
                        livros.favorito === "favorito"
                          ? desfavoritar(livros.idLivro)
                          : favoritar(livros.idLivro)
                      }
                      checkedIcon={<Favorite style={{ color: "var(--cor-roxoEscuro)" }} />}
                    />
                  </div>
                  <div className="card" key={livros.id}>
                    <img
                      className="card-img"
                      src={ReadingBookConcept}
                      alt="Livro Aberto"
                    />
                    <h1 className="card-title">{livros.titulo}</h1>
                    <p className="autor">{livros.autor}</p>
                    <p className="genero">
                      {Array.isArray(livros.genero)
                        ? livros.genero[0]
                        : "Sem gênero"}
                    </p>
                    <p className="ano-publicacao">{livros.anoPublicacao}</p>

                    <button
                      className="card-link-telaperfil"
                      onClick={() => handleVisualizar(livros)}
                    >
                      Visualizar mais{" "}
                      <img src={iconOlhoAberto} alt="ícone de olho aberto" />
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="sem-favoritos">
                <img
                  src={ReadingBookConcept}
                  alt="Sem livros favoritos"
                  className="imagem-sem-favoritos"
                />
                <p>Você não tem livros favoritos.</p>
              </div>
            )}
          </div>
        </div>
        <button
          className="seta seta-direita"
          onClick={proximo}
          disabled={
            indice >= livrosExibidos.length - 3 || livrosExibidos.length === 0
          }
        >
          &gt;
        </button>
      </div>

      <ModalInfoLivro
        abrirModal={abrirModal}
        fecharModal={() => {
          carregarDados();
          setAbrirModal(false);
        }}
        sinopse={livroSelecionado?.sinopse}
        nome={livroSelecionado?.nome}
        avaliacao={livroSelecionado?.quantidadeEstrelas}
        genero={livroSelecionado?.genero}
        livrosDisponiveis={livroSelecionado?.livrosDisponiveis}
        data={livroSelecionado?.data}
        idLivro={livroSelecionado?.id}
        favorito={livroSelecionado?.favoritado}
        autor={livroSelecionado?.autor}
        quantidadeAvaliacoes={livroSelecionado?.quantidadeAvaliacoes}
      />
    </>
  );
}
